//cp index.html 404.html

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { creteTheme, ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import {
  createBrowserRouter,
  RouterProvider,
  BrowserRouter,
  Route,
  Routes,
  Link,
} from "react-router-dom";
import NbevSurvey from "./pages/NbevSurvey";
import ErrorPage from "./pages/ErrorPage";
import AbInBevSurvey from "./pages/AbInBevSurvey";
import SABsurvey from "./pages/SAB-survey";
import Welcome from "./pages/Welcome";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Welcome />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/:id",
    element: <App />,
    errorElement: <ErrorPage />,
  },

  {
    path: "/sab-survey",
    element: <SABsurvey />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/abinbev-survey",
    element: <AbInBevSurvey />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/nbev-survey",
    element: <NbevSurvey />,
    errorElement: <ErrorPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
const basename = process.env.PUBLIC_URL || "";

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      {/* <RouterProvider router={router} /> */}
      <BrowserRouter basename={basename}>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/:id" element={<App />} />
          <Route path="/sab-survey" element={<SABsurvey />} />
          <Route path="/abinbev-survey" element={<AbInBevSurvey />} />
          <Route path="/nbev-survey" element={<NbevSurvey />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
